module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bamboo-collection@2x_7c0b13.jpg";